import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanDeleteDriver = (): boolean => {
  const [canDeleteDriver, setCanDeleteDriver] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const deleteAllPermission: Permission = {
    resource: 'drivers',
    action: 'deletebasic',
    scope: 'all',
  };
  const deleteProviderPermission: Permission = {
    resource: 'drivers',
    action: 'deletebasic',
    scope: 'provider',
  };

  const canDeleteAll = useHasPermission(user, deleteAllPermission);
  const canDeleteProvider = useHasPermission(user, deleteProviderPermission);

  React.useEffect(() => {
    setCanDeleteDriver(canDeleteAll || canDeleteProvider);
  }, [canDeleteAll, canDeleteProvider]);

  return canDeleteDriver;
};
